import React from 'react';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import { List } from '@fiverr-private/list';
import { atoms } from '@fiverr-private/theme';
import { Stack } from '@fiverr-private/layout_components';
import { useCollapsibleSkills, useMonitoring, SkillTag } from '@fiverr-private/seller_pages_toolbox';
import { SkillItem } from '../SkillItem/SkillItem';
import { ButtonExpansionLess, ButtonExpansionMore } from '../../ButtonExpansion';

interface ExpertiseListProps {
    items: SkillTag[];
}

export const ExpertiseList = ({ items }: ExpertiseListProps) => {
    const { Providers, fireEvents } = useMonitoring();

    const { isShowingMore, showCollapsedSkills, showLessCollapsedSkills, visibleSkills, collapsedSkills } =
        useCollapsibleSkills({
            withClamp: true,
            skills: items,
        });

    const onClickMore = () => {
        fireEvents({
            [Providers.Mixpanel]: {
                type: 'view + more expertise full list',
            },
        });
        showCollapsedSkills();
    };

    const onClickLess = () => {
        fireEvents({
            [Providers.Mixpanel]: {
                type: 'view + less expertise full list',
            },
        });
        showLessCollapsedSkills();
    };

    if (isEmpty(items)) {
        return null;
    }

    const skillsTotalCount = visibleSkills.length + collapsedSkills.length;

    const shouldRenderMoreButton = !isEmpty(collapsedSkills) && !isShowingMore;
    const shouldRenderLessButton = !isEmpty(collapsedSkills) && isShowingMore;
    const shouldRenderAdditionalSkills = !isEmpty(collapsedSkills) && isShowingMore;

    return (
        <Stack direction="column" alignItems="flexStart" gap="3">
            <List
                gap="2"
                aria-label="Skills List"
                paddingLeft="0"
                className={classNames(
                    atoms({
                        display: 'flex',
                        flexWrap: 'wrap',
                    })
                )}
            >
                {visibleSkills.map((skill, index) => (
                    <SkillItem key={`${skill.text}_${index}`} skillText={skill.text} skillUrl={skill.url} shouldLink />
                ))}
                {shouldRenderAdditionalSkills &&
                    collapsedSkills.map((skill) => (
                        <SkillItem key={skill.text} skillText={skill.text} skillUrl={skill.url} shouldLink />
                    ))}
            </List>
            {shouldRenderMoreButton && <ButtonExpansionMore onClick={onClickMore} totalCount={skillsTotalCount} />}
            {shouldRenderLessButton && <ButtonExpansionLess onClick={onClickLess} />}
        </Stack>
    );
};
